import { z } from 'zod';

export const BiaRpoCalculationSchema = z.object({
    _id: z.string().optional(),
    application: z.string().min(1, 'Application is required'),
    transaction: z.string().optional(),
    type: z.string().optional(),
    avgTransHr: z.string().optional(),
    backupFreq: z.string().optional(),
    restoreTime: z.string().optional(),
    transLoss: z.string().optional(),
    transLossCount: z.string().optional(),
    maxAllowableLoss: z.string().optional(),
    rpo: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});
